<template>
	<div class="hello">
		<div class="header">
			<div @click="backJump" style="color: #fff;padding-top: 10px;margin-left: 10px;">
				<span style="line-height: 30px;"><i class="van-icon van-icon-arrow-left van-nav-bar__arrow"></i>返回</span>
			</div>
			<div class="clear"></div>
			<img src="../assets/topback.png" style="width: 50%;height: 75%;float: right;margin-top: -10px;" alt="">
			<div>
				<h2><span>用</span>量记录</h2>
			</div>
		</div>
		<div class="content" style="position: relative;">
			<div class="center">
				<div class="center_al">
					<div class="bt">
						<img src="../assets/water.png" >
						<span>水费</span>
					</div>
					<div class="cont_top">
						
						<div>
							<span class="left">识别编码信息</span><span class="right">{{account}}</span>
						</div>
						<div>
							<span class="left">住址信息</span><span class="right">{{address}}</span>
						</div>
					</div>
				</div>
				
			</div>
			<div class="cont_center">
				<div class="center_con">
					<p>使用明细（吨）</p>
					<div class="btnal">
						<div :style="month" @click="echange(0)">
							<span>月用水费</span>
						</div>
						<div :style="day" @click="echange(1)">
							<span>日用水费</span>
						</div>
					</div>
					<div :style="tian" style="position: absolute;margin-top: 10px;width: 100%;z-index: 10;">
						<button style="border:none;border-radius: 50px;width: 20%;height: 30px;z-index: 30;" :style="butcolweek" @click="weeks()">7天</button>
						<button style="border:none;border-radius: 50px;width: 20%;height: 30px;z-index: 30;" :style="butcolmonth" @click="months()">30天</button>
					</div>
					<div id="main" style="width: 100%;height: 300px;"></div>
					<div :style="tian">
						<ul class="day" >
							<li style="color: #8E8E8E;height: 27px;text-align: center;">
								<div style="float: left;width: 50%;background-color: #EFF1F0 ;line-height: 27px;">
									<span>时间</span>
								</div>
								<div style="float: left;width: 50%;background-color: #EFF1F0 ;line-height: 27px;">
									<span>水量（吨）</span>
								</div>
							</li>
							<li v-for="item in dayfa" style="height: 27px;;margin-top:20px;text-align: center;border-bottom: 1px solid #DEE1E5;">
								<div style="float: left;width: 50%;line-height: 27px;">
									<span style="color: #8E8E8E;">{{item.date | formatDate}}</span>
								</div>
								<div style="float: left;width: 50%;line-height: 27px;">
									<span>{{item.all}}</span>
								</div>
							</li>
							<li style="height: 27px;;margin-top:20px;text-align: center;">
								<div style="float: left;width: 50%;text-align: center;line-height: 27px;">
									<span>合计</span>
								</div>
								<div style="float: left;width: 50%;line-height: 27px;">
									<span>{{total}}</span>
								</div>
							</li>
						</ul>
					</div>
					<div :style="yue">
						<ul class="date">
							<li style="color: #8E8E8E;height: 27px;text-align: center;">
								<div style="float: left;width: 50%;background-color: #EFF1F0 ;line-height: 27px;">
									<span>时间</span>
								</div>
								<div style="float: left;width: 50%;background-color: #EFF1F0 ;line-height: 27px;">
									<span>水量（吨）</span>
								</div>
							</li>
							<li v-for="item in dats" style="height: 27px;;margin-top:20px;text-align: center;border-bottom: 1px solid #DEE1E5;">
								<div style="float: left;width: 50%;line-height: 27px;">
									<span style="color: #8E8E8E;">{{item.date | formatMonth}}</span>
								</div>
								<div style="float: left;width: 50%;line-height: 27px;">
									<span>{{item.all}}</span>
								</div>
							</li>
							<li style="height: 27px;;margin-top:20px;text-align: center;">
								<div style="float: left;width: 50%;text-align: center;line-height: 27px;">
									<span>合计</span>
								</div>
								<div style="float: left;width: 50%;line-height: 27px;">
									<span>{{total}}</span>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import * as echarts from 'echarts';
  import {waterContent,waterMonthContent} from "../common/api/wateragain";
  import jump from "../common/jump";
	export default{
		data(){
			return{
				yue:{
					 marginBottom: '20px',
					display:'none'
				},
				tian:{
					 marginBottom: '20px',
					display:'block'
				},
				month:{
					color:'#95c4fb',
					width:'80px',
					height:'30px',
					backgroundColor:'#4e9df9',
					borderRadius:'50px',
					marginTop:'5px',
					marginLeft:'14px',
					textAlign:'center',
					lineHeight:'30px'
				},
				day:{
					color:'#0f72dd',
					width:'80px',
					height:'30px',
					backgroundColor:'#fff',
					borderRadius:'50px',
					marginTop:'5px',
					marginLeft:'14px',
					textAlign:'center',
					lineHeight:'30px'
				},
				account:'',
				address:'',
				payer:'',
        total:'',
				dayfa:[
				],
				dats:[
				],
				startTime:'',
				endTime:'',
				ycontent:[],
				all:[],
				butcolweek:{
					backgroundColor:'#4e9df9',
					color:'#fff'
				},
				butcolmonth:{
					backgroundColor:'#fff',
					color:'#000'
				},
			}
		},
		mounted() {
			this.account = this.$route.query.houseHold
			this.address = this.$route.query.address
			this.payer = this.$route.query.payer
			this.startend(13)
			console.log(this.$cookies.get("token"))
      waterContent({houseHoldNumber:this.account,startTime:this.startTime,endTime:this.endTime}).then((response)=>{
			  console.log(response.data)
			  let dats = []
			  for(let i =0;i<response.data.items.length;i++){
				  dats.push(response.data.items[i].usedTotal)
			  }
			  this.all = dats
			  for(let i =0;i<response.data.items.length;i++){
			  	this.dayfa.push({all:response.data.items[i].usedTotal,date:response.data.items[i].billTimestamp})
			  }
			  console.log(this.all)
			  this.everydate(7)
			  this.echart()
			})
			.catch(function (error) {
			  console.log(error);
			});
			
		},
		methods:{
      backJump(){
        this.$destroy()
        jump.$emit('back')
        this.$router.go(-1)
      },
			everydate:function(day){
				var myDate = new Date() // 获取今天日期
        myDate.setDate(myDate.getDate() - day-1)
        var dateArray = []
        var dateTemp
        var flag = 1
        for (var i = 0; i < day; i++) {
          dateTemp = (myDate.getMonth() + 1) + '-' + myDate.getDate()
          dateArray.push(dateTemp)
          myDate.setDate(myDate.getDate() + flag)
        }
        this.ycontent = dateArray
        console.log(this.ycontent)
        console.log(dateArray)
			},
			echart(){
				var myChart = echarts.init(document.getElementById('main'));
				var option = {
				  xAxis: {
					type: 'category',
					data: this.ycontent
				  },
				  yAxis: {
					type: 'value'
				  },
				  series: [
					{
					  data: this.all,
					  type: 'line'
					}
				  ]
				};	
				myChart.setOption(option);
			},
			startend(shij){
				var com = this.getDay(-shij)+" 00:00:00:000"
				var dat = new Date(com);
				var time1 = dat.getTime();
				console.log(time1)
				this.startTime = time1
				const nowDate = new Date();
				const date = {year: nowDate.getFullYear(),month: nowDate.getMonth() + 1,date: nowDate.getDate()}
				const newmonth = date.month>10?date.month:'0'+date.month
				const day = date.date>10?date.date:'0'+date.date
				let systemDate = date.year + '-' + newmonth + '-' + day +" 00:00:00:000"
				var datend = new Date(systemDate);
				var tim = datend.getTime()
				console.log(tim)
				this.endTime = tim
				console.log(this.startTime)
				console.log(this.endTime)
			},
			getDay(day) {
        var today = new Date();　　
        var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;　　
        today.setTime(targetday_milliseconds);　　
        var tYear = today.getFullYear();　　
        var tMonth = today.getMonth();　　
        var tDate = today.getDate();　　
        tMonth = this.doHandleMonth(tMonth + 1);　　
        tDate = this.doHandleMonth(tDate);　　
        return tYear + "-" + tMonth + "-" + tDate;
      },
      doHandleMonth(month) {　　
        var m = month;　　
        if (month.toString().length == 1) {　　
          m = "0" + month;　　
        }　　
        return m;
      },
			echange:function(zhi){
				if(zhi == "0"){
					this.month.backgroundColor = '#fff'
					this.month.color = '#0f72dd'
					this.day.backgroundColor = '#4e9df9'
					this.day.color = '#95c4fb'
					this.yue.display = 'block'
					this.tian.display = 'none'
          this.startend(30)
					waterMonthContent({
						  houseHoldNumber:this.account,
						  startTime:this.startTime,
						  endTime:this.endTime
					  }).then((response)=>{
					  console.log(response.data);
					  let content =[]
					  for(let i =0;i<response.data.items.length;i++){
					  	content.push({all:response.data.items[i].usedTotal,date:response.data.items[i].billTimestamp})
					  }
					  this.dats = content
					  console.log(this.dats)
					})
					.catch(function (error) {
					  console.log(error);
					});
				}
				else if(zhi == "1"){
					this.day.backgroundColor = '#fff'
					this.day.color = '#0f72dd'
					this.month.backgroundColor = '#4e9df9'
					this.month.color = '#95c4fb'
					this.yue.display = 'none'
					this.tian.display = 'block'
				}
			},
			weeks:function(){
				this.everydate(7)
				this.butcolweek.backgroundColor = '#4e9df9',
				this.butcolweek.color = '#fff',
				this.butcolmonth.backgroundColor = '#fff',
				this.butcolmonth.color = '#000',
				this.startend(7)
				console.log(this.startTime)
        waterContent({
					  houseHoldNumber:this.account,
					  startTime:this.startTime,
					  endTime:this.endTime
				  }).then((response)=>{
				  console.log(response.data)
				  let dats = []
				  for(let i =0;i<response.data.items.length;i++){
					  dats.push(response.data.items[i].usedTotal)
				  }
				  this.all = dats
				  this.echart()
				  console.log(this.all)
				})
			},
			months:function(){
				console.log("111"),
				this.everydate(30)
				this.butcolmonth.backgroundColor = '#4e9df9',
				this.butcolmonth.color = '#fff',
				this.butcolweek.backgroundColor = '#fff',
				this.butcolweek.color = '#000',
				this.startend(30),
				console.log(this.startTime)
        waterContent({
					  houseHoldNumber:this.account,
					  startTime:this.startTime,
					  endTime:this.endTime
				  }).then((response)=>{
				  console.log(response.data)
				  // console.log(response.data.data.items.length)
				  let dats = []
				  console.log(this.option)
				  for(let i =0;i<response.data.items.length;i++){
					 dats.push(response.data.items[i].usedTotal)
				  }
				  this.all = dats
				  this.echart()
				  // console.log(this.all)
				})
				.catch(function (error) {
				  console.log(error);
				});
			}
			
		},
		filters: {
		      formatDate: function (value) {
		        let date = new Date(value);
		        let y = date.getFullYear();
		        let MM = date.getMonth() + 1;
		        MM = MM < 10 ? ('0' + MM) : MM;
		        let d = date.getDate();
		        d = d < 10 ? ('0' + d) : d;
		        let h = date.getHours();
		        h = h < 10 ? ('0' + h) : h;
		        let m = date.getMinutes();
		        m = m < 10 ? ('0' + m) : m;
		        let s = date.getSeconds();
		        s = s < 10 ? ('0' + s) : s;
		        return y + '.' + MM + '.' + d;
		      },
			  formatMonth: function (value) {
			    let date = new Date(value);
			    let y = date.getFullYear();
			    let MM = date.getMonth() + 1;
			    MM = MM < 10 ? ('0' + MM) : MM;
			    let d = date.getDate();
			    d = d < 10 ? ('0' + d) : d;
			    let h = date.getHours();
			    h = h < 10 ? ('0' + h) : h;
			    let m = date.getMinutes();
			    m = m < 10 ? ('0' + m) : m;
			    let s = date.getSeconds();
			    s = s < 10 ? ('0' + s) : s;
			    return y + '.' + MM ;
			  },
			}
	}
</script>

<style scoped>
	.header{
		width: 100%;
		height: 25vh;
		background-color: #295ad0;
	}
	
	.header h2{
		letter-spacing:2px;
		color: rgb(255, 255, 255);
		line-height: 50px;
		position: relative;
		margin-left:20px
	}
	.header h2 span{
		border-bottom: 3px solid #fff;
	}
	.center{
		width: 90%;
		height: 300px;
		margin: 0 auto;
		border:1px solid #dee1e5;
		box-shadow: #dee1e5 0px 0px 1px 1px;
		border-radius: 10px;
		margin-top:-20px;
		background-color: #fff;
	}
	.center_al{
		width: 80%;
		margin: 0 auto;
	}
	.bt{
		margin-top:20px
	}
	.bt img{
		width: 38px;
		height:38px;
		float: left;
	}
	.bt span{
		line-height: 42px;
		margin-left: 10px;
		font-size: 20px;
	}
	.bt p{
		color:#0f72dd
	}
	.cont_top{
		
		margin-top:20px
	}
	.cont_top div{
		height: 30px;
		margin-top: 55px;
		border-bottom: 1px solid #9D9D9D;
	}
	.cont_top div .left{
		color:#8e8e8e;
		float: left;
	}
	.cont_top div .right{
		color:#000;
		float: right;
	}
	.cont_center{
		width: 90%;
		margin: 0 auto;
		border:1px solid #dee1e5;
		border-radius: 10px;
		margin-top:20px;
		
	}
	.center_con{
		width:80%;
		margin: 0 auto;
		padding-top: 10px;
	}
	.center_con p{
		color:#0f72dd;
	}
	.btnal{
		width:200px;
		background-color: #4e9df9;
		height:40px;
		border-radius: 50px;
		margin: 0 auto;
	}
	.btnal div{
		float: left;
	}
</style>
